import {formDataToRequestParams, getAxios} from './axios'
import {addAuthTokenData} from './member';

import {responseResolveInterceptor} from './interceptors';

export function getAmateurFilm(params) {
    let axios = getAxios();

    return axios.request({
        url: '/amateur_film/',
        method: 'get',
        params: addAuthTokenData(params)
    });
}

export function incrementAmateurFilmViews(id) {
    let axios = getAxios();

    return axios.request({
        url: '/member/amateur_film/view/',
        method: 'post',
        data: formDataToRequestParams({'id' : id})
    });
}

export function likeAmateurFilm({id}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/amateur_film/like/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function commentAmateurFilm({id, comment}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/amateur_film/comment/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id, comment}))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/amateurFilm.js